import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider, ThemeProvider } from '@dreamtree-org/twreact-ui';
import '@dreamtree-org/twreact-ui/dist/index.css';
import './theme/tokens.css';
import './index.css';
import App from './App.jsx';
import { restoreBrand } from './theme/applyTheme';

// Apply any saved per-tenant brand before first paint (runtime theming).
restoreBrand();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <StoreProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StoreProvider>
  </React.StrictMode>
);
